<template>
    <v-tab-item
        eager
    >
        <v-row>
            <v-col cols="12" class="col-sm-2 pt-6">
                <span class="font-weight-medium">{{$t('processingPhases')}}</span>
            </v-col>
            <v-col cols="12" class="col-sm-10">
                <v-tabs
                    v-model="activeTab"
                    active-class=" body-2 font-weight-bold text-capitalize text--main-yellow"
                    slider-color="orange lighten-2"
                    background-color="transparent"
                    ref="tabs"
                >
                    <v-tab
                        v-for="(tab, idx) in calculation.treatments"
                        :key="idx"
                    >T{{ idx }}</v-tab>
                </v-tabs>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                <v-tabs-items
                    background-color="transparent"
                    v-model="activeTab"
                >
                    <tab-result
                        v-for="(tab, idx) in calculation.treatments"
                        :key="idx"
                        :calculationIdx="calculationIdx"
                        :treatmentIdx="idx"
                        :results="results[idx]"
                        :cultures="cultures"
                        :categories="categories"
                        :attributes="attributes"
                        @send-to-common-result="calculateCultureResult($event, idx)"
                        @recalculate="$emit('recalculate')"
                    ></tab-result>
                </v-tabs-items>
            </v-col>
        </v-row>
        <v-divider></v-divider>
        <v-row v-if="cultureResults.length > 0">
            <v-col cols="12">
                <div class="px-2 pt-4 pb-10">
                    <span class="d-block text-body-1 font-weight-bold">{{ $t('targetBudget') }} {{ $t('processingHectares') }}: {{ formatPrice(cultureGivenBudget) }} {{ currency.symbol }}</span>
                    <span class="d-block text-body-1 font-weight-bold">{{ $t('actualBudget') }} {{ $t('processingHectares') }}: {{ formatPrice(cultureRealBudget) }} {{ currency.symbol }}</span>
                    <span class="d-block text-body-1t" :class="savingClass">{{ savingTitle }} {{ formatPrice(Math.abs(cultureBudgetDifference)) }} {{ currency.symbol }} / га {{ $t('or') }} {{ Math.abs(cultureBudgetDifferenceInPercent).toFixed(2) }}&percnt;</span>
                </div>
                <div class="d-flex justify-center">
                    <v-btn
                        depressed
                        class="caption  white--text main--yellow"
                        @click="addAllToBasket"
                        :disabled="basketButtonPressed"
                    >{{$t('addToBasket')}}&nbsp;{{ $t('selectedDrugs') }}</v-btn>
                </div>
            </v-col>
        </v-row>
    </v-tab-item>
</template>

<script>
import TabResult from "./TabResult";
import CalculatorDataProvider from "../../../../app-front/mixins/CalculatorDataProvider";
import Stepper from "../../../../app-front/mixins/Stepper";
import numberFormat from "../../../../utils/numberFormat";
import BasketService from "../../../../app-front/services/api/BasketService";

export default {
    name: "CultureTabResult",
    components: {
        TabResult
    },
    mixins: [ CalculatorDataProvider, Stepper ],
    props: [ 'calculationIdx', 'results', 'cultures', 'categories', 'attributes' ],
    data() {
        return {
            activeTab: 0,
            cultureResults: [],
            basketButtonPressed: false,
        }
    },
    computed: {
        calculation() {
            return this.calculatorFullData[this.calculationIdx];
        },
        currency() {
            return this.$store.getters.currencies.find(item=>item.name === this.$store.getters.appCurrency);
        },
        cultureGivenBudget() {
            let res = 0;
            this.cultureResults.forEach(item => {
                if(item.tabGivenBudget !== 0) {
                    res += parseFloat(item.tabGivenBudget);
                }
            })
            return res;
        },
        cultureRealBudget() {
            let res = 0
            this.cultureResults.forEach(item => {
                if(item.tabRealBudget !== 0) {
                    res += parseFloat(item.tabRealBudget);
                }
            })
            return res;
        },
        cultureBudgetDifference() {
            return this.cultureGivenBudget - this.cultureRealBudget;
        },
        cultureBudgetDifferenceInPercent() {
            return this.cultureBudgetDifference / this.cultureGivenBudget * 100;
        },
        savingClass() {
            return this.cultureBudgetDifference > 0 ? 'teal--text' : 'red--text';
        },
        savingTitle() {
            return this.cultureBudgetDifference > 0 ? this.$t('saving') : this.$t('overprice');
        },
        productsForBasket() {
            let res = [];
            this.cultureResults.forEach(tab=>{
                tab.tabCheckedDrugs.forEach(drugType=>{
                    drugType.selectedDrugs.forEach(drug=>{
                        const idx = res.findIndex(item => item.productId === drug.id);
                        if (idx < 0){
                            res.push({
                                id: drug.id,
                                quantity: drug.quantity
                            })
                        } else {
                            res[idx].quantity += drug.quantity;

                        }
                    });
                });
            })
            return res;
        },
    },
    methods: {
        calculateCultureResult(data, index){
            if(data.tabCheckedDrugs.length > 0) {
                this.$set(this.cultureResults, index, data);
            } else {
                this.cultureResults.splice(index, 1);
            }
        },
        formatPrice(sum) {
            return numberFormat(sum, 2, '.', ' ');
        },
        addAllToBasket() {
            if(this.isUserLoggedIn) {
                BasketService.updateList(this.productsForBasket)
                    .then(res => {
                        this.$store.commit('setBasket', res.data);
                    })
                    .catch(err => console.log(err));
            } else {
                this.addToNoLoginBasket(this.productsForBasket);
            }
            this.$emit('add-all-to-basket');
            this.basketButtonPressed = true;
        },
    },
    watch: {
        cultureResults(value) {
            this.$emit('set-selected-products', value)
        }
    }
}
</script>

<style scoped>

</style>
